<template>
  <v-container
    style="
      padding: 0;
      margin-top: 122px;
    "
    fluid
  >
    <status-bar :showCompletedButton="showCompletedButton" :showBackButton="true"></status-bar>

    <v-container>
      <v-row>
        <v-card class="mx-5">
          <v-card-title>
            <h1 class="display-1">
              Manage Customers
            </h1>
          </v-card-title>
          <v-card-text>
            <v-col cols="12" class="d-flex">
              <div class="flex-grow-1">
                <p class="mb-3">
                  First, upload your customer list in bulk using the sample CSV file.
                </p>
                <p class="mb-3">
                  If you do not have a CSV file of your customer list, then you will need to add their information individually.
                </p>
                <p class="mb-3">
                  For all new potential customers, you will need to add their information individually and proceed to the Send Bids page.
                </p>
                <p class="mb-3">
                  You can also upload a CSV after you have started your list. New rows are added to the customers already on file.
                </p>
              </div>
              <div @click="toSendBids()" class="text-right flex-shrink-0">
                <v-btn class="ma-5">Send Bids</v-btn>
              </div>
            </v-col>
            <v-col cols="12">
              <p class="mb-3">
                If you have a list of your current clients on your computer, you can upload them here and send them a level-pay subscription offer on the Send Bids page.
              </p>
              <p class="mb-3">
                Uploading your customer list is simple. You just need to make a spreadsheet that is properly formatted for our system. You can download a sample spreadsheet <a href="#" @click.prevent="downloadSampleCsv" class="download-link">here</a>. It has the correct headings and formatting. You can use Microsoft Excel, Google Sheets, or another spreadsheet tool. You may even want to ask your accountant for help with this step.
              </p>
              <p class="mb-3">
                When you have everything formatted correctly, save it to your computer as a CSV file. Click the paperclip icon below to upload the CSV file from your computer into our system.
              </p>
              <p class="mb-3">
                Select the "Offer Deadline" for your subscription offer, then a "Send File" button will appear. Click that button and you're all set!
              </p>
              <p class="mb-4">
                If you have any questions, please email support@certainfee.com.
              </p>
            </v-col>
            <v-col cols="12">
              <upload-csv ref="uploadCsv" @updateShowCompletedButton="updateCompletedButton" :key="key"></upload-csv>
            </v-col>
            <v-col cols="12">
              <customer-list @updateShowCompletedButton="updateCompletedButton" :key="key"></customer-list>
            </v-col>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>

    <Footer></Footer>

  </v-container>
</template>

<script>
// import _ from "lodash"

import { DB } from '../firebase/db'
import { mapState } from 'vuex'
import router from '../router'

import UploadCsv from '@/components/UploadCsv.vue'
import CustomerList from '@/components/CustomerList.vue'
import StatusBar from '@/components/StatusBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'UploadCustomers',
  data() {
    return {
      showCompletedButton: false
    }
  },
  computed: {
    ...mapState(['key', 'user']),
  },
  methods: {
    downloadSampleCsv() {
      this.$refs.uploadCsv.createCsv()
    },
    updateCompletedButton() {
      this.showCompletedButton = true
    },
    getSLPData() {
      // Get SLP Data here
      let customerAccountRef = DB.collection("user").doc(this.user.uid)

      customerAccountRef
        .get()
        .then((user) => {
          user = user.data()
          if(user.slpAgreement != undefined > 0 && user.customerList.length > 0) {
            this.showCompletedButton = true
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    toSendBids() {
      if(this.$route.name !== 'SLPAgreement') {
        router.push({ name: 'SLPAgreement' })
      }
    }
  },
  components: {
    UploadCsv,
    CustomerList,
    StatusBar,
    Footer,
  },
  mounted() {
    this.getSLPData()
  }
}
</script>

<style scoped>
.download-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}
.download-link:hover {
  color: #1565c0;
}
</style>